import { render } from "./bids.vue?vue&type=template&id=8b8db7c6&scoped=true"
import script from "./bids.vue?vue&type=script&lang=js"
export * from "./bids.vue?vue&type=script&lang=js"

import "./bids.vue?vue&type=style&index=0&id=8b8db7c6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b8db7c6"]])

export default __exports__